import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';

const HomeHero = () => {
  const heroRef = useRef(null);
  
  useEffect(() => {
    // Müzik notaları animasyonu
    const createMusicNotes = () => {
      const container = document.querySelector('.music-notes-container');
      if (!container) return;
      
      // Önceki notaları temizle
      container.innerHTML = '';
      
      // Yeni notalar oluştur
      for (let i = 0; i < 15; i++) {
        const note = document.createElement('div');
        const size = Math.random() * 24 + 12;
        const position = Math.random() * 100;
        const delay = Math.random() * 5;
        const duration = Math.random() * 10 + 15;
        const opacity = Math.random() * 0.3 + 0.1;
        
        note.className = 'absolute text-white';
        note.style.fontSize = `${size}px`;
        note.style.left = `${position}%`;
        note.style.top = '-50px';
        note.style.opacity = opacity;
        note.style.animation = `floatUp ${duration}s linear ${delay}s infinite`;
        
        const symbols = ['♪', '♫', '♬', '♩', '♭', '♮', '♯'];
        note.textContent = symbols[Math.floor(Math.random() * symbols.length)];
        
        container.appendChild(note);
      }
    };
    
    // Metin animasyonu
    const animateText = () => {
      const title = document.querySelector('.hero-title');
      const description = document.querySelector('.hero-description');
      const buttons = document.querySelectorAll('.hero-button');
      const card = document.querySelector('.hero-card');
      
      if (title) title.classList.add('animate-fadeInUp');
      
      if (description) {
        setTimeout(() => {
          description.classList.add('animate-fadeInUp');
        }, 300);
      }
      
      buttons.forEach((button, index) => {
        setTimeout(() => {
          button.classList.add('animate-fadeInUp');
        }, 600 + index * 150);
      });
      
      if (card) {
        setTimeout(() => {
          card.classList.add('animate-fadeInRight');
        }, 900);
      }
    };
    
    createMusicNotes();
    animateText();
    
    // Cleanup
    return () => {
      const container = document.querySelector('.music-notes-container');
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <section ref={heroRef} className="relative min-h-screen flex items-center overflow-hidden">
      {/* Koyu ve yüksek kontrast arkaplan */}
      <div className="absolute inset-0 bg-indigo-950"></div>
      
      {/* Işık efektleri */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/30 via-purple-900/20 to-indigo-900/30"></div>
      
      {/* Müzik notaları */}
      <div className="music-notes-container absolute inset-0 overflow-hidden"></div>
      
 {/* Main content - Yüksek kontrast metin renkleri */}
<div className="container mx-auto px-6 py-24 relative z-20 flex flex-col lg:flex-row items-center justify-between">
  <div className="lg:w-1/2 text-center lg:text-left mb-16 lg:mb-0">
  <div className="relative p-8 rounded-xl bg-gradient-to-br from-indigo-800 via-blue-900 to-blue-500 border border-indigo-400/40 shadow-2xl shadow-indigo-500/20 hover:shadow-indigo-500/40 transition-all duration-500">
      <h1 className="hero-title text-5xl md:text-6xl lg:text-7xl font-bold mb-8 opacity-0 tracking-tight">
        <span className="block text-white text-shadow-xl">İYTE</span>
        <span className="block text-indigo-300 drop-shadow-[0_0_0_2px_white] shadow-[0_0_10px_rgba(79,70,229,0.7)]">
          Müzik Topluluğu
        </span>
      </h1>
      <p className="hero-description text-xl text-white mb-12 max-w-xl mx-auto lg:mx-0 opacity-0 text-shadow-lg leading-relaxed">
        İzmir Yüksek Teknoloji Enstitüsü'nün müzik tutkunu öğrencilerinin bir araya geldiği topluluk. Konserler, atölyeler ve müzik etkinlikleriyle kampüs yaşamına renk katıyoruz.
      </p>
      <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
        <Link to="/about" className="hero-button transform animate-fadeIn delay-300">
          <Button
            variant="outline"
            className="px-8 py-3 rounded-full border-2 border-indigo-300 text-indigo-100 bg-indigo-800/30 hover:bg-indigo-600 hover:border-indigo-500 hover:text-white transition-all duration-300 font-bold shadow-lg shadow-indigo-500/20 hover:shadow-indigo-500/40"
          >
            Bizi Tanıyın
          </Button>
        </Link>
        <Link to="/reserve" className="hero-button transform animate-fadeIn delay-500">
          <Button
            className="px-8 py-3 rounded-full bg-gradient-to-r from-indigo-400 to-purple-500 text-white hover:from-indigo-500 hover:to-purple-600 transition-all duration-300 shadow-lg shadow-purple-500/20 hover:shadow-purple-500/40 font-bold"
          >
            Rezervasyon Yap
          </Button>
        </Link>
      </div>
    </div>
  </div>


        
        <div className="lg:w-5/12">
        <div className="hero-card bg-white p-8 rounded-2xl shadow-2xl border border-white/50 transform hover:scale-105 transition-all duration-300">
            <h3 className="text-2xl font-bold text-indigo-900 mb-6">Etkinliklerimiz</h3>
            <p className="text-indigo-800 mb-8">Yıl boyunca düzenlediğimiz çeşitli etkinliklerle hem üyelerimize kendilerini geliştirme ve sergileme fırsatı sunuyor, hem de kampüs yaşamına müziğin renklerini katıyoruz.</p>
            <Link to="/events" className="block">
              <Button 
                fullWidth 
                className="py-4 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:from-indigo-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl font-bold"
              >
                Etkinlikleri Keşfet
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Scrolldown indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce z-20">
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
      
      {/* Animated wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
          <path fill="#f8fafc" fillOpacity="1" d="M0,224L48,229.3C96,235,192,245,288,218.7C384,192,480,128,576,117.3C672,107,768,149,864,181.3C960,213,1056,235,1152,218.7C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" className="animate-pulse" style={{animationDuration: '10s'}}></path>
        </svg>
      </div>
      
      {/* Text shadow styles */}
      <style>
        {`
        .text-shadow {
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
        }
        
        .text-shadow-lg {
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
        }
        
        .text-shadow-xl {
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8), 0 4px 12px rgba(0, 0, 0, 0.5);
        }
        
        @keyframes floatUp {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: var(--opacity);
          }
          90% {
            opacity: var(--opacity);
          }
          100% {
            transform: translateY(-100vh) rotate(360deg);
            opacity: 0;
          }
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease forwards;
        }
        
        .animate-fadeInRight {
          animation: fadeInRight 0.8s ease forwards;
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}
      </style>
    </section>
  );
};

export default HomeHero;